import {
    Component,
    ContentChild,
    Directive,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnInit,
    Output,
    TemplateRef,
    ViewChild,
} from '@angular/core';

import { TranslationKeyMap } from '../coaching-insight.i18n';

@Directive({
    selector: '[viewTrigger]',
})
export class TriggerReferenceDirective {
    @Input() toggle: boolean;
    @Output() public click: EventEmitter<any>;

    constructor(public elRef: ElementRef) {
        this.click = new EventEmitter<any>();
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ngOnChanges(args) {
        // eslint-disable-next-line no-prototype-builtins
        if (args.hasOwnProperty('toggle')) {
            this.click.emit();
        }
    }

    @HostListener('click', ['$event'])
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    triggerClick(event) {
        if (event) {
            this.click.emit();
        }
    }
}

@Component({
    selector: 'cmps-ui-dropdown',
    templateUrl: './ui-dropdown.component.html',
})
export class CmpsUIDropdownComponent implements OnInit {
    @Input() selected: any;
    @Input() options: any[];
    @Input() optionTemplate: TemplateRef<any>;
    @Input() searchResultTemplate: TemplateRef<any>;
    @Input() loadingTemplate: TemplateRef<any>;
    @Input() searchResults: any[] = [];
    @Input() searchQuery: any;
    @Input() dropdownPosition: string;
    @Input() loading: boolean = false;
    @Output() selectedChange: EventEmitter<any>;
    @Output() opened: EventEmitter<boolean>;

    @ViewChild('arrow') arrow: ElementRef;
    @ViewChild('optionsContainer') optionsContainer: ElementRef;

    @ContentChild(TriggerReferenceDirective) trigger: TriggerReferenceDirective;

    public name: string = 'test';
    public focused: boolean = false;

    i18n = TranslationKeyMap;

    constructor(private readonly _eref: ElementRef) {
        this.dropdownPosition = 'right';
        this.selectedChange = new EventEmitter<any>();
        this.opened = new EventEmitter<boolean>();
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ngOnInit() {
        if (this.options == null) {
            this.options = [];
        }
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ngAfterContentInit() {
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        if (this.trigger && this.trigger.click) {
            this.trigger.click.subscribe((e) => {
                this.toggle(null);
            });
        }
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    toggle(force: boolean) {
        this.focused = force != null ? force : !this.focused;
        if (!this.focused) {
            this.opened.emit(this.focused);
            this.clearSearch();
        } else {
            this.opened.emit(this.focused);
        }
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    select(option: any, noToggle?: boolean, shouldEmit?: boolean) {
        if (!option) return;

        option = this.options.find((d) => d.value === option.value);

        if (!option) {
            console.error('Invalid option.');
            return false;
        }

        setTimeout(
            () => {
                if (noToggle == null) {
                    this.toggle(false);
                }

                this.selectedChange.emit(option);
            },
            noToggle != null ? 0 : 300,
        ); // half second delay for when selecting from dropdown.
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    search() {
        const x = []; // this._teamOAService.searchTeam(this.searchQuery);

        this.searchResults = x.map((res) => {
            const j = this.options.filter((t) => {
                return t.value === res.value;
            });
            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
            if (j && j.length) {
                res.favorite = true;
            }
            return res;
        });
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    clearSearch() {
        this.searchResults = [];
    }
}
